// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__cG3sE","title":"Images90_title__3-TMW","images":"Images90_images__RuMJM"};